// fitvids to make all videos full width http://fitvidsjs.com/  
(function(e){"use strict";e(function(){e(".the-content").fitVids()})})(jQuery);